import { render } from "./Prompt.vue?vue&type=template&id=308f5bc2&scoped=true"
import script from "./Prompt.vue?vue&type=script&lang=js"
export * from "./Prompt.vue?vue&type=script&lang=js"

import "./Prompt.vue?vue&type=style&index=0&id=308f5bc2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308f5bc2"]])

export default __exports__